import Footer from '../../components/landing/Footer'

export default Footer
